import { render, staticRenderFns } from "./Prof.vue?vue&type=template&id=748c3e65&"
import script from "./Prof.vue?vue&type=script&lang=js&"
export * from "./Prof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports